import { AssessmentComponent, AssessmentStateEntry } from "@pandas/assessment-engine";
import { AssessmentComponentType, AssessmentResult } from "@pandas/http-client/platform";

type Mapping = Record<string, AssessmentComponent>;

export const assessmentKeysMapping: Mapping = {
	Digitizer: "digitizer",
	Microphone: "audio",
	Speaker: "audio",
	Multitouch: "multitouch",
	"Unlock Sensor": "biometrics",
	Gyroscope: "gyroscope",
	"Front Camera": "front-camera-ai",
	"Back Camera": "back-camera-ai",
	"Front Side": "grader-front-cosmetics",
	"LCD Blemishes": "grader-lcd-condition",
	Display: "grader-lcd-condition",
	"Back Side": "grader-back-cosmetics",
	"Body Frame": "grader-body-frame-cosmetics",
	"Back Cameras": "grader-camera-cosmetics",
	"Device Skin": "grader-device-skin",
};

export function mapAssessmentResults(
	assessments: Array<AssessmentResult>,
	typeFilter: AssessmentComponentType,
): Array<AssessmentStateEntry> {
	const filteredAssessmentsByGroup = assessments.filter((result) => result.component_type === typeFilter);
	return filteredAssessmentsByGroup.map((item) => {
		const assessmentKey = assessmentKeysMapping[item.component];

		return {
			assessmentKey,
			condition: item.condition,
			componentName: item.component,
		} as AssessmentStateEntry;
	});
}
